import { Api, ConfigHelper, createApiService } from 'relapp-api';

export default {
    ...createApiService('dns'),

    /**
     * Creates a DNS zone for the domain name.
     *
     * @param {string} domainName
     *
     * @return {Promise}
     */
    createZone(domainName) {
        const route = ConfigHelper.apiUrl('dns.zone', [
            {
                key: '{domain}',
                value: domainName
            }
        ]);

        return Api.post(route);
    }
};
